module.exports = __webpack_public_path__ + "static/media/warner-logo.0e118206.svg";